// Generated from the approved MagicPath revision 440407782647271424. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const qualificationPlate = "/assets/page09-who-for.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const forYou = ['You’re done with average.', 'You take responsibility.', 'You want more—out of yourself.', 'You’re willing to do the work.'];
const notForYou = ['You want quick fixes.', 'You blame circumstances.', 'You’re not ready to be honest.', 'You’re here to be entertained.'];
export const Page09WhoThisIsFor = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  const [focus, setFocus] = useState<'for' | 'not' | null>(null);
  return <main className="who-page">
    <img className="who-photo" src={qualificationPlate} alt="Pale dawn above an open ocean" />
    <div className="who-grade" aria-hidden="true" />
    <button className="who-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="who-navigation" aria-label="Primary navigation">
      {navigation.map((item, index) => <span key={item}><button type="button" className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>{index === 0 && <i aria-hidden="true">•</i>}</span>)}
    </nav>

    <section className="who-columns" aria-label="Who House 45 is and is not for">
      <button className={focus === 'for' ? 'who-column focused' : 'who-column'} type="button" onMouseEnter={() => setFocus('for')} onMouseLeave={() => setFocus(null)} onFocus={() => setFocus('for')} onBlur={() => setFocus(null)}>
        <i aria-hidden="true" /><h1>FOR YOU IF</h1>{forYou.map(line => <p key={line}>{line}</p>)}
      </button>
      <button className={focus === 'not' ? 'who-column focused' : 'who-column'} type="button" onMouseEnter={() => setFocus('not')} onMouseLeave={() => setFocus(null)} onFocus={() => setFocus('not')} onBlur={() => setFocus(null)}>
        <i aria-hidden="true" /><h2>NOT FOR YOU IF</h2>{notForYou.map(line => <p key={line}>{line}</p>)}
      </button>
    </section>

    <footer className="who-footer">
      <div className="who-progress">{Array.from({
          length: 7
        }).map((_, index) => <i key={index} className={index < 2 ? 'active' : ''} />)}</div>
      <strong>09 / 11</strong><span>WHO THIS IS FOR</span>
    </footer>
  </main>;
};